import Sidebar from "../../components/partials/Sidebar";
import { lazy, Suspense, useEffect, useState } from "react";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import StatsLoading from "../../components/Stats/StatsLoading";
import TopItemsTableLoading from "../../components/TopItemsTable/TopItemsTableLoading";
import BarChartLoadingComp from "../../components/BarChart/BarChartLoading";
import LineChartLoadingComp from "../../components/LineChart/LineChartLoading";
import $ from "jquery";
import config from "../../config";
import Select from "react-select";
import moment from "moment";

const Stats = lazy(() => import("../../components/Stats/Stats"));
const BarChartComp = lazy(() => import("../../components/BarChart/BarChart"));
const LineChartComp = lazy(
  () => import("../../components/LineChart/LineChart"),
);
const TopItemsTable = lazy(
  () => import("../../components/TopItemsTable/TopItemsTable"),
);

function Dashboard() {
  const [isExpand, setIsExpand] = useState(false);
  const [isExpand1, setIsExpand1] = useState(false);
  const [onboardDate, setOnboardDate] = useState("");
  const [role, setRole] = useState("");

  // Date range state
  const [dateRangeList, setDateRangeList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(null);

  // Branch state
  const [branchList, setBranchList] = useState([
    { label: "All Branch", value: "" },
  ]);
  const [selectedBranch, setSelectedBranch] = useState({
    label: "All Branch",
    value: "",
  });

  // Date range display state
  const [dateRangeDisplay, setDateRangeDisplay] = useState("");

  // Generate last 12 months range
  // const getLast12MonthsRange = () => {
  //   const endDate = moment().endOf("month"); // current month end
  //   const startDate = moment().subtract(11, "months").startOf("month"); // 11 months back, month start

  //   console.log(
  //     "startDate",
  //     startDate.format("YYYY-MM-DD"),
  //     "endDate",
  //     endDate.format("YYYY-MM-DD"),
  //   );

  //   return {
  //     label: "Last 12 Months",
  //     value: {
  //       from_date: startDate.format("YYYY-MM-DD"),
  //       to_date: endDate.format("YYYY-MM-DD"),
  //     },
  //   };
  // };

  // getLast12MonthsRange function को fix करें
  const getLast12MonthsRange = () => {
    const endDate = moment(); // आज की date (10 March 2026)
    const startDate = moment().subtract(12, "months"); // 11 months back

    console.log(
      "startDate",
      startDate.format("YYYY-MM-DD"),
      "endDate",
      endDate.format("YYYY-MM-DD"),
    );

    return {
      label: "Last 12 Months",
      value: {
        from_date: startDate.format("YYYY-MM-DD"),
        to_date: endDate.format("YYYY-MM-DD"), // आज तक, month end नहीं
      },
    };
  };

  // UI के लिए better date display
  const formatDateRangeDisplay = (dateRange) => {
    if (!dateRange?.value) return "";

    const { from_date, to_date } = dateRange.value;
    const from = moment(from_date).format("DD MMM YYYY");
    const to = moment(to_date).format("DD MMM YYYY");

    // Better formatting
    if (dateRange.label === "Last 12 Months") {
      return `${from} to ${to} (${dateRange.label})`;
    }
    return `${from} - ${to}`;
  };

  // Generate yearly ranges from onboard year to current year
  const generateYearlyRanges = (onboardYear) => {
    const currentYear = new Date().getFullYear();
    const yearlyRanges = [];

    for (let year = onboardYear; year <= currentYear; year++) {
      yearlyRanges.push({
        label: `${year}`,
        value: {
          from_date: `${year}-01-01`,
          to_date: `${year}-12-31`,
        },
      });
    }
    return yearlyRanges;
  };

  // Format date range display
  // const formatDateRangeDisplay = (dateRange) => {
  //   if (!dateRange?.value) return "";

  //   const { from_date, to_date } = dateRange.value;
  //   const from = moment(from_date).format("DD MMM YYYY");
  //   const to = moment(to_date).format("DD MMM YYYY");

  //   if (dateRange.label === "Last 12 Months") {
  //     return `Last 12 Months: ${from} to ${to}`;
  //   }
  //   return `${dateRange.label}: ${from} to ${to}`;
  // };

  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      const inventoryData = JSON.parse(localStorage.getItem("inventory"));

      setRole(inventoryData?.userData?.role_id);
      const onboardDateStr =
        inventoryData?.userData?.comp_data[0]?.createdAt || "2025-08-15";
      setOnboardDate(onboardDateStr);

      // Generate date range options
      const onboardYear = new Date(onboardDateStr).getFullYear();
      const last12Months = getLast12MonthsRange();
      const yearlyRanges = generateYearlyRanges(onboardYear);

      const dateRanges = [last12Months, ...yearlyRanges];
      setDateRangeList(dateRanges);
      setSelectedDateRange(dateRanges[dateRanges.length - 1]); // Default to Current Year
    }
  }, []);

  // Update date range display when selection changes
  useEffect(() => {
    if (selectedDateRange) {
      setDateRangeDisplay(formatDateRangeDisplay(selectedDateRange));
    }
  }, [selectedDateRange]);

  // Branch list useEffect (unchanged)
  useEffect(() => {
    const getBranchList = async () => {
      await $.post(
        `${config.apiUrl}/branch/listBranch`,
        JSON.stringify({ paginate: 0, is_active: 1 }),
      )
        .done(function (res) {
          let listData = [{ label: "All Branch", value: "" }];
          for (let item of res.data?.list) {
            listData.push({
              label: item.branch_name,
              value: item.branch_id,
            });
          }
          setBranchList(listData);
        })
        .catch(function (err) {
          console.error(err);
          setBranchList([{ label: "All Branch", value: "" }]);
        });
    };
    getBranchList();
  }, []);

  return (
    <div
      className="d-flex min-vh-100 main-Wrapper"
      style={{ background: "#DAE5FF" }}
    >
      <Sidebar />
      <div
        className="content m-1 p-3"
        key={`${selectedBranch.value}-${selectedDateRange?.value?.from_date}`}
      >
        <Header />
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <Breadcrumb path={[]} />
          <div className="d-flex gap-2 flex-row align-items-center">
            {/* Branch Select */}
            {role == 2 ? (
              <div style={{ width: "220px" }}>
                <Select
                  options={branchList}
                  value={selectedBranch}
                  onChange={setSelectedBranch}
                  placeholder="Select Branch..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "36px",
                      height: "36px",
                      borderRadius: "10px",
                      borderColor: "#e2e8f0",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      fontSize: "13px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 8px",
                      height: "36px",
                    }),
                  }}
                  classNamePrefix="react-select"
                />
              </div>
            ) : null}

            {/* Date Range Select with inline badge */}
            <div
              className="d-flex align-items-center bg-white px-2 rounded-3 shadow-sm border"
              style={{ borderColor: "#e2e8f0", height: "38px" }}
            >
              <div style={{ width: "115px" }}>
                <Select
                  options={dateRangeList}
                  value={selectedDateRange}
                  onChange={setSelectedDateRange}
                  placeholder="Year"
                  isSearchable={false}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "36px",
                      height: "36px",
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 4px",
                      height: "36px",
                      display: "flex",
                      alignItems: "center",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#1e293b",
                      margin: 0,
                      lineHeight: "36px",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "36px",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      padding: "0 2px",
                      color: "#94a3b8",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                  classNamePrefix="react-select"
                />
              </div>
              <div
                className="text-muted small fw-medium d-flex align-items-center ps-2 pe-1 border-start"
                style={{
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  height: "22px",
                }}
              >
                <span className="me-1">📅</span>
                <span>{dateRangeDisplay}</span>
              </div>
            </div>
          </div>
        </div>

        <main id="dashboard">
          <div className="container-fluid py-2 px-0">
            <div className="row mb-4">
              <Suspense fallback={<StatsLoading />}>
                <Stats
                  branch={selectedBranch}
                  dateRange={selectedDateRange?.value}
                />
              </Suspense>
            </div>

            <div className="row g-4">
              <div className={`col-${isExpand ? "12" : "12"} transition-all`}>
                <Suspense fallback={<BarChartLoadingComp />}>
                  <BarChartComp
                    isExpand={isExpand}
                    setIsExpand={setIsExpand}
                    branch={selectedBranch}
                    dateRange={selectedDateRange?.value}
                  />
                </Suspense>
              </div>

              <div className="col-6">
                <Suspense fallback={<TopItemsTableLoading />}>
                  <TopItemsTable
                    branch={selectedBranch}
                    dateRange={selectedDateRange?.value}
                  />
                </Suspense>
              </div>
              <div className={`col-${isExpand1 ? "12" : "6"} transition-all`}>
                <div className="row mb-4">
                  <Suspense fallback={<LineChartLoadingComp />}>
                    <LineChartComp
                      isExpand={isExpand1}
                      setIsExpand={setIsExpand1}
                      branch={selectedBranch}
                      dateRange={selectedDateRange?.value}
                    />
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
